export default __webpack_public_path__ + "static/media/zac.8002f99e.png";